import {
  Decision,
  RateClass,
  TobaccoClass,
} from '../../../common/constants/decision';
import { ProductConfig } from '../../../common/productConfig/productConfig';
import { IDecisionRequest } from '../interfaces/IDecisionRequest';

export interface DecisionConfig {
  decision: Decision;
  buildPayload: (
    formData: any,
    productConfig?: ProductConfig | null,
    isPolicyActivated?: boolean,
  ) => Partial<IDecisionRequest>;
}

function buildClrFields(
  formData: { triggerClr?: boolean; haltClrReasons?: string[] },
  isPolicyActivated?: boolean,
): Pick<IDecisionRequest, 'haltClr' | 'haltClrReasons'> {
  const haltClr = formData.triggerClr === false;
  const haltClrReasons = haltClr ? formData.haltClrReasons : undefined;
  if (isPolicyActivated) {
    return { haltClr, haltClrReasons };
  }
  return {};
}

export const DECISION_CONFIGS: Record<string, DecisionConfig> = {
  approve: {
    decision: Decision.APPROVED,
    buildPayload: (formData, productConfig, isPolicyActivated) => {
      const tableRating =
        formData.paValue === undefined ? 'PA100' : formData.paValue;
      return {
        rateClass: productConfig?.hasRateClass()
          ? (formData.selectedRateClass?.label as RateClass)
          : (null as any),
        tobaccoClass: productConfig?.hasRateClass()
          ? (formData.selectedTobaccoClass?.label as TobaccoClass)
          : (null as any),
        term: formData.term,
        tableRating: productConfig?.hasTableRating()
          ? tableRating
          : (null as any),
        debits: productConfig?.hasDebits() ? formData.debits : (null as any),
        doctorInfo: formData.doctorInfo,
        amendment: formData.amendment,
        coverage: formData.maxCoverage,
        otafReasons: formData.showOtaf
          ? formData.selectedOtafReasons
          : undefined,
        otafDescription: formData.showOtaf
          ? formData.otafDescription
          : undefined,
        mibCodes: formData.mibCodes,
        ridersInfo: formData.riders,
        ...buildClrFields(formData, isPolicyActivated),
      };
    },
  },

  decline: {
    decision: Decision.DECLINED,
    buildPayload: (formData, _productConfig, isPolicyActivated) => ({
      declineReasons: formData.reasons,
      declineDescription: formData.declineDescription,
      declineConditions: formData.declineConditions,
      mibCodes: formData.mibCodes,
      ...buildClrFields(formData, isPolicyActivated),
    }),
  },

  postpone: {
    decision: Decision.POSTPONED,
    buildPayload: formData => {
      const haltClr = formData.triggerClr === false;
      const haltClrReasons = haltClr ? formData.haltClrReasons : undefined;
      return {
        postponeReasons: formData.reasons,
        postponeDescription: formData.postponeDescription,
        postponeConditions: formData.postponeConditions,
        mibCodes: formData.mibCodes,
        haltClr,
        haltClrReasons,
      };
    },
  },

  waive: {
    decision: Decision.WAIVED,
    buildPayload: formData => ({
      waiveDescription: formData.description,
    }),
  },

  ineligible: {
    decision: Decision.INELIGIBLE,
    buildPayload: formData => ({
      ineligibleReasons: [formData.reason],
      ineligibleDescription: '-',
      mibCodes: formData.mibCodes || [],
      ridersInfo: formData.riders,
    }),
  },

  reinstate_agree: {
    decision: Decision.APPROVED,
    buildPayload: () => ({}),
  },

  reinstate_disagree: {
    decision: Decision.DECLINED,
    buildPayload: formData => ({
      declineDescription: formData.description,
    }),
  },

  reinstate_withdraw: {
    decision: Decision.WITHDRAWN,
    buildPayload: formData => ({
      withdrawReason: formData.description,
    }),
  },
};
